const authToken = {
    get: () => {
        return localStorage.getItem('apiToken') || '';
    },
    set: (token) => {
        localStorage.setItem('apiToken', token || '');
    }
};
export default authToken;